module.exports = __webpack_public_path__ + "static/creative-agency-d2f34aae28fc9cbcb1e65d1cb465c187.gif";